import axios from 'axios'
import store from '@/store'

let handlingUnauthorized = false

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    'Content-Type': 'application/json',
    'X-API-KEY': process.env.VUE_APP_API_SECRETKEY_API
  },
  withCredentials : true,
})

// Interceptor de request
instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

    return config
  }, error => {
    return Promise.reject(error)
  })

// Interceptor de response
instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
   const status = error.response ? error.response.status : null
    if (status === 401 && !handlingUnauthorized) {
      handlingUnauthorized = true

      store.dispatch('logout')

      setTimeout(() => {
        handlingUnauthorized = false
      }, 2000)
    }

    return Promise.reject(error)
  }
)

export default instance
